"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractDIDStore = void 0;
/**
 * An abstract class for the {@link @veramo/did-manager#DIDManager} identifier store
 * @public
 */
class AbstractDIDStore {
}
exports.AbstractDIDStore = AbstractDIDStore;
//# sourceMappingURL=abstract-identifier-store.js.map